import { type CommandProperties, createCommand } from '@atlassian/rovo-content-bridge-api';

export type SmartCreationModalActivatedCommandProperties = CommandProperties & {
	type: 'page' | 'whiteboard' | 'jira';
};

/**
 * A command sent by a bridge API client to announce that the Smart Creation Modal is activated.
 *
 * @summary {@link CommandProperties.senderId} is notifying {@link CommandProperties.receiverId} that the
 * Smart Creation Modal is activated. This can be used to determine what the
 * parent Rovo chat instance should target when making mutations.
 */
export const SmartCreationModalActivatedCommand = createCommand<
	SmartCreationModalActivatedCommandProperties,
	void
>('smart-creation-modal-activated');

/**
 * @description Should emit this command when the Smart Creation Modal is deactivated.
 */
export type SmartCreationModalDeactivatedCommandProperties = CommandProperties & {
	type: 'page' | 'whiteboard' | 'jira';
};

/**
 * A command sent by a bridge API client to announce it is about to be deactivated.
 *
 * @summary {@link CommandProperties.senderId} is notifying {@link CommandProperties.receiverId} that the
 * Smart Creation Modal is about to be deactivated, and therefore inaccessible to the user.
 */
export const SmartCreationModalDeactivatedCommand = createCommand<
	SmartCreationModalDeactivatedCommandProperties,
	void
>('smart-creation-modal-deactivated');
